import React from 'react';

function Experience() {
  return (
    <section className="tc-experience-style1 section-padding-x" id='aboutme'>
      <div className="container-fluid">
        <div className="row justify-content-between align-items-center">
          <div className="col-lg-2">
             <div className="rotate-txt justify-content-lg-end">
              <ul>
                <li>
                  <a href="mailto:afthab98950@gmail.com"> afthab98950@gmail.com</a>
                </li>
                <li>
                  <a href="tel:9895096500"> +91 9895096500 </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="img wow">
              <img
                src="/home1/assets/img/afthab3.jpeg"
                alt=""
                className="img-cover img-gray"
              />
            </div>
          </div>
          <div className="col-lg-5">
            <div className="info wow fadeInUp" data-wow-delay="0.3s">
              <h3 className="fsz-45 fw-600 mb-30">About me </h3>
              <div className="text fsz-15 color-666">
                My personality is characterized by
                curiosity, dedication, and a hands-
                on approach. I am eager to
                combine my scientific understanding of the land with my
                visual aptitude for design. I am
                pursuing an MA in Landscape
                Architecture to fuse my agricultural
                knowledge with advanced design
                theory and practice, with the goal
                of creating purposeful, sustainable,
                and beautifully articulated outdoor
                spaces.
              </div>
              <br/>
              <div className="text fsz-15 color-666">
                <b>Agriculture 1 month training Section : </b><br/>harvesting, planting, soil testing during the training / 2024<br/>
           
              </div>
              <div className="text fsz-15 color-666">
              <b>Art Section : </b><br/>showcase detail work / 2023-24
              </div>

              <a
                href="#contact"
                className="butn rounded-pill mt-50 hover-bg-black bg-white"
              >
                <span>
                  Contact Me <i className="small ms-1 ti-arrow-top-right"></i>
                </span>
              </a>
            </div>
          </div>
         
        </div>
      </div>
      <img src="/home1/assets/img/c_line.png" alt="" className="c-line wow" />
    </section>
  );
}

export default Experience;
